import React, { useState } from 'react';
import { connect } from 'redux-zero/react';
import { combineActions } from 'redux-zero/utils';
import { useTranslation } from 'react-i18next';

import { DsTabs, DsTab, DsBadge } from '@tokenyico/design-system/dist/reactJS';
import { formActions, holderActions } from 'app/state/actions';
import { TableView } from 'app/components';
import RequestsTableWrapper from './RequestsTableWrapper';

import './Requests.less';

const RequestsView = ({
  setError,
  setPendingRequests,
  holder: { selectedToken, pendingRequests },
}) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);

  const numberOfPendingRequests = pendingRequests > 0 ? `${pendingRequests}` : '';

  return (
    <TableView id="requests">
      <div className="requests__tabs">
        <DsTabs onTabChange={({ detail }) => setCurrentTab(detail)} currentTab={currentTab}>
          <DsTab activeClassName="tab--neutral" padding="1rem 1.3rem">
            <span>{t('shared.createdByMe')}</span>
          </DsTab>

          <DsBadge
            hasShadow
            version="warning"
            label={numberOfPendingRequests}
            size="xs"
            customPosition={{
              top: '1rem',
              right: '1.15rem',
            }}
          >
            <DsTab
              activeClassName={pendingRequests > 0 ? 'tab--warning' : 'tab--neutral'}
              padding="1rem 1.6rem "
            >
              <span>{t('shared.sentToMe')}</span>
            </DsTab>
          </DsBadge>
        </DsTabs>
      </div>

      {currentTab === 0 ? (
        <RequestsTableWrapper
          key={0}
          setError={setError}
          setPendingRequests={setPendingRequests}
          selectedToken={selectedToken}
          currentTab={currentTab}
        />
      ) : (
        <RequestsTableWrapper
          key={1}
          setError={setError}
          setPendingRequests={setPendingRequests}
          selectedToken={selectedToken}
          currentTab={currentTab}
        />
      )}
    </TableView>
  );
};

const mapToProps = (state) => state;

export default connect(mapToProps, combineActions(formActions, holderActions))(RequestsView);
